import { Button, Card, Tag } from "antd";
import React, { useState } from "react";
import Icon from "../../../assets/Icon";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import SkillModal from "./modals/SkillModal";
import Utils from "../../utils/Utils";

function TwoWaySkill({
  skillAnalysisDataObj,
  switchSystem,
  interviewId,
  auth,
  interviewType,
  getReport,
  skillRefs,
}) {
  const [skillModal, setSkillModal] = useState(false);
  const [skillModalData, setSkillModalData] = useState(null);
  const skillAnalysisData = skillAnalysisDataObj?.map((skill) => ({
    subSkills: switchSystem ? skill.tags : skill.editedTags,
    score: switchSystem ? skill.score : skill.editedScore,
    verdict: switchSystem ? skill.verdict : skill.editedVerdict,
    skill: skill.skill,
    negativeRemarks: switchSystem
      ? skill.negativeRemarks
      : skill.editedNegativeRemarks,
    positiveRemarks: switchSystem
      ? skill.positiveRemarks
      : skill.editedPositiveRemarks,
    edited: skill.edited,
    candidateInterviewSkillId: skill.candidateInterviewSkillId,
  }));

  return (
    <>
      {skillModal && (
        <SkillModal
          skillModal={skillModal}
          setSkillModal={setSkillModal}
          skillModalData={skillModalData}
          interviewType={interviewType}
          auth={auth}
          interviewId={interviewId}
          getReport={getReport}
        />
      )}
      <div className="mt-10">
        <div className="flex gap-3 items-center font-semibold text-[1.275rem]">
          <p className="bg-[#206DC5] border inline-block p-3 rounded-xl">
            <Icon type="skill-analysis-icon" width="18" height="19" />
          </p>
          <span>Skill Analysis</span>
        </div>
        {skillAnalysisData?.map((item, i) => (
          <Card
            key={i}
            ref={skillRefs[item?.candidateInterviewSkillId]}
            className="bg-[#D4E7FD] mt-4 border-2 border-[#A9CFFB]"
          >
            <div className="flex justify-between items-center mb-2 ">
              <p className="text-[#206DC5] text-2xl font-semibold ">
                {Utils.toTitleCase(item?.skill) || "N/A"}
              </p>
              {!switchSystem && (
                <p className="flex  items-center justify-center  ">
                  {item?.edited && <p>Edited*</p>}
                  <Button
                    type="link"
                    onClick={() => {
                      setSkillModal(true);
                      setSkillModalData(item);
                    }}
                  >
                    <Icon type="skill-edit-modal-icon" width="16" height="16" />
                  </Button>
                </p>
              )}
            </div>
            <p>
              {item?.subSkills?.map((language, index) => (
                <Tag key={language} color={Utils.getTagColor(index)}>
                  {language}
                </Tag>
              ))}
            </p>
            <div className="print:flex-row print:items-stretch flex flex-col mt-2 md:flex-row w-full items-center gap-y-3 gap-x-4">
              <Card className="print:w-[60%] bg-white md:w-[60%] w-full">
                <div className="print:h-full h-[17rem] scroll overflow-y-auto px-2">
                  <p className="font-semibold text-lg">Strength</p>
                  <ul
                    className="mt-[.2rem] text-[#475467]"
                    style={{ listStyleType: "disc", paddingLeft: "20px" }}
                  >
                    {item?.positiveRemarks?.map((data, i) => (
                      <li key={i} className="my-[.12rem] avoid-break">
                        {data}
                      </li>
                    ))}
                  </ul>

                  <p className="font-semibold text-lg mt-4">Weakness</p>
                  <ul
                    className="mt-[.2rem] text-[#475467]"
                    style={{ listStyleType: "disc", paddingLeft: "20px" }}
                  >
                    {item?.negativeRemarks?.map((data, i) => (
                      <li key={i} className="my-[.12rem] avoid-break">
                        {data}
                      </li>
                    ))}
                  </ul>
                </div>
              </Card>
              <Card className="print-right-card print:h-auto bg-white md:w-[40%] w-full text-center h-[20rem] flex items-center justify-center border">
                <div
                  style={{ width: 200, height: 120 }}
                  className="relative m-auto"
                >
                  <CircularProgressbar
                    // text="4"
                    className="rounded-lg"
                    value={item?.score * 20}
                    circleRatio={0.5}
                    strokeWidth={10}
                    styles={buildStyles({
                      // Rotation of path and trail
                      rotation: 0.75,

                      // Make the progress rounded
                      strokeLinecap: "round", // 'round' will make the progress path have rounded edges

                      // Text size and position
                      textSize: "16px",
                      text: {
                        transform: "translateY(-50px)", // Move text slightly up
                        fontWeight: "bold",
                      },

                      // Path animation duration
                      pathTransitionDuration: 0.5,

                      // Colors
                      pathColor: `#53A0F8`,
                      textColor: "#206DC5",

                      trailColor: "#d6d6d6",
                      backgroundColor: "#3e98c7",
                    })}
                  />
                  <div className="absolute top-[85px] left-1/2 -translate-x-1/2 -translate-y-1/2 font-bold text-[2rem] text-[#206DC5]">
                    {item?.score < 0 ? "N/A" : item?.score}
                  </div>
                </div>
                <p className="font-semibold mt-4 text-xl text-center">
                  Score Justification
                </p>
                <p className="text-[#475467] mt-1 px-2 print:h-auto h-[6.8rem] scroll overflow-y-auto text-[.88rem] leading-[1.3rem]">
                  {item?.verdict || "N/A"}
                </p>
              </Card>
            </div>
          </Card>
        ))}
      </div>
    </>
  );
}

export default TwoWaySkill;
